"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmazonBaseUrl = exports.getUSAmazonBaseUrl = exports.getUKAmazonBaseUrl = exports.getSpainAmazonBaseUrl = exports.getJapanAmazonBaseUrl = exports.getItalyAmazonBaseUrl = exports.getGermanyAmazonBaseUrl = exports.getFranceAmazonBaseUrl = exports.getCanadaAmazonBaseUrl = exports.getBrazilAmazonBaseUrl = void 0;
const types_1 = require("../stage/types");
const types_2 = require("./types");
const getAmazonBaseUrlFromStageMapping = (stage, mapping) => stage === types_1.Stage.Prod || stage === types_1.Stage.Gamma ? mapping[stage] : mapping.default;
const getBrazilAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.com.br',
    [types_1.Stage.Gamma]: 'br-pre-prod.amazon.com',
    default: 'br-development.amazon.com'
});
exports.getBrazilAmazonBaseUrl = getBrazilAmazonBaseUrl;
const getCanadaAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.ca',
    [types_1.Stage.Gamma]: 'ca-pre-prod.amazon.com',
    default: 'ca-development.amazon.com'
});
exports.getCanadaAmazonBaseUrl = getCanadaAmazonBaseUrl;
const getFranceAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.fr',
    [types_1.Stage.Gamma]: 'fr-pre-prod.amazon.com',
    default: 'fr-development.amazon.com'
});
exports.getFranceAmazonBaseUrl = getFranceAmazonBaseUrl;
const getGermanyAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.de',
    [types_1.Stage.Gamma]: 'de-pre-prod.amazon.com',
    default: 'de-development.amazon.com'
});
exports.getGermanyAmazonBaseUrl = getGermanyAmazonBaseUrl;
const getItalyAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.it',
    [types_1.Stage.Gamma]: 'it-pre-prod.amazon.com',
    default: 'it-development.amazon.com'
});
exports.getItalyAmazonBaseUrl = getItalyAmazonBaseUrl;
const getJapanAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.co.jp',
    [types_1.Stage.Gamma]: 'jp-pre-prod.amazon.com',
    default: 'jp-development.amazon.com'
});
exports.getJapanAmazonBaseUrl = getJapanAmazonBaseUrl;
const getSpainAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.es',
    [types_1.Stage.Gamma]: 'es-pre-prod.amazon.com',
    default: 'es-development.amazon.com'
});
exports.getSpainAmazonBaseUrl = getSpainAmazonBaseUrl;
const getUKAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.co.uk',
    [types_1.Stage.Gamma]: 'uk-pre-prod.amazon.com',
    default: 'uk-development.amazon.com'
});
exports.getUKAmazonBaseUrl = getUKAmazonBaseUrl;
const getUSAmazonBaseUrl = (stage) => getAmazonBaseUrlFromStageMapping(stage, {
    [types_1.Stage.Prod]: 'www.amazon.com',
    [types_1.Stage.Gamma]: 'pre-prod.amazon.com',
    default: 'development.amazon.com'
});
exports.getUSAmazonBaseUrl = getUSAmazonBaseUrl;
const getAmazonBaseUrl = (country, stage) => {
    switch (country) {
        case types_2.Country.Brazil:
            return (0, exports.getBrazilAmazonBaseUrl)(stage);
        case types_2.Country.Canada:
            return (0, exports.getCanadaAmazonBaseUrl)(stage);
        case types_2.Country.France:
            return (0, exports.getFranceAmazonBaseUrl)(stage);
        case types_2.Country.Germany:
            return (0, exports.getGermanyAmazonBaseUrl)(stage);
        case types_2.Country.Japan:
            return (0, exports.getJapanAmazonBaseUrl)(stage);
        case types_2.Country.Italy:
            return (0, exports.getItalyAmazonBaseUrl)(stage);
        case types_2.Country.Spain:
            return (0, exports.getSpainAmazonBaseUrl)(stage);
        case types_2.Country.UK:
            return (0, exports.getUKAmazonBaseUrl)(stage);
        case types_2.Country.US:
            return (0, exports.getUSAmazonBaseUrl)(stage);
        default:
            throw new Error(`Unable to get Amazon base url for "${country}" country and "${stage}"`);
    }
};
exports.getAmazonBaseUrl = getAmazonBaseUrl;
__exportStar(require("./types"), exports);
